import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import clsx from 'clsx';

export const isValidIds = (val) => {
  if (!/[^0-9-]/g.test(val) || !/[^0-9,]/g.test(val) || !/[^0-9]/g.test(val)) {
    if (val?.includes?.('-') && !val?.split('-')?.filter((item) => item == '')?.length && val?.split('-')?.length == 2) {
      return true;
    } else if (val?.includes?.(',') && !val?.split(',')?.filter((item) => item == '')?.length) {
      return true;
    } else if (!/[^0-9]/g.test(val)) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

function SelectionFilter({ isFeedback, isApplicants, onSubmit, disabled, form, submitButtonText = 'Применить', showSubmitButton = true }) {
  let navigate = useNavigate();
  const created_at_to = form.watch('created_at_to');
  const created_at_from = form.watch('created_at_from');
  const [number, setNumber] = useState();
  const [fio, setFio] = useState();
  const [ageFrom, setAgeFrom] = useState();
  const [ageTo, setAgeTo] = useState();
  console.log(form.watch());
  console.log(isValidIds(number));

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (number !== undefined) {
        form.setValue('number', number);
        form.trigger('number');
      }
    }, 600);
    return () => clearTimeout(timeout);
  }, [number]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (fio !== undefined) {
        form.setValue('full_name', fio);
      }
    }, 600);
    return () => clearTimeout(timeout);
  }, [fio]);
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (ageFrom !== undefined) {
        form.setValue('age_from', ageFrom);
      }
    }, 600);
    return () => clearTimeout(timeout);
  }, [ageFrom]);
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (ageTo !== undefined) {
        form.setValue('age_to', ageTo);
      }
    }, 600);
    return () => clearTimeout(timeout);
  }, [ageTo]);
  const errorNumber = form?.formState?.errors?.number;
  console.log(errorNumber);

  return (
    <div className="flex flex-col w-full p-4 rounded-md shadow-[0_0_3px_#C4C4C4]">
      <div className="mb-6">
        <p className="text-xl font-medium">Фильтр</p>
      </div>
      {!isFeedback && (
        <div className="mb-2">
          <input
            type="text"
            name="name"
            id="name"
            className={clsx('block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-blue-500 focus:outline-none sm:text-sm sm:leading-6', errorNumber && 'ring-red-300 focus:ring-red-500 placeholder:text-red-400')}
            placeholder="Порядковый номер"
            {...form.register('number', {
              validate: (val) => {
                if (!isValidIds(val)) {
                  return 'Ошибка';
                }
              },
            })}
            onChange={(e) => {
              setNumber(e.target.value);
            }}
          />
        </div>
      )}

      <div className="mb-2">
        <input
          type="text"
          name="name"
          id="name"
          className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-gray-300 placeholder:text-gray-400 focus:ring-1 focus:ring-blue-500 focus:outline-none sm:text-sm sm:leading-6"
          placeholder="ФИО"
          {...form.register('full_name')}
          onChange={(e) => {
            setFio(e.target.value);
          }}
        />
      </div>

      <div className="mb-2">
        <select id="gender" name="gender" className="block w-full rounded-md border-0 p-2 text-gray-900 shadow-sm ring-1 outline-none ring-gray-300 focus:ring-1 focus:ring-blue-500 sm:text-sm sm:leading-6" {...form.register('sex')}>
          <option value="false"> Мужской </option>
          <option value={'true'}> Женский </option>
          <option value={'null'}> Неважно </option>
        </select>
      </div>

      <div className="flex flex-row mb-2 gap-x-2">
        <div className="relative w-1/2 rounded-md shadow-sm">
          <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-2">
            <span className="text-gray-500 sm:text-sm"> от</span>
          </div>
          <input
            type="number"
            name="min_date"
            id="min_date"
            min={1}
            className="block w-full rounded-md border-0 py-2 pl-7 pr-7 text-gray-900 ring-1 ring-inset ring-gray-300 outline-none placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
            {...form.register('age_from')}
            onChange={(e) => {
              setAgeFrom(e.target.value);
            }}
          />
          <div className="absolute inset-y-0 right-0 flex items-center pr-2">
            <span className="text-gray-500 sm:text-sm">лет</span>
          </div>
        </div>
        <div className="relative w-1/2 rounded-md shadow-sm">
          <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-2">
            <span className="text-gray-500 sm:text-sm"> от</span>
          </div>
          <input
            type="number"
            name="max_date"
            id="max_date"
            className="block w-full rounded-md border-0 py-2 pl-7 pr-7 text-gray-900 ring-1 ring-inset ring-gray-300 outline-none placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-blue-500 sm:text-sm sm:leading-6"
            {...form.register('age_to')}
            onChange={(e) => {
              setAgeTo(e.target.value);
            }}
          />
          <div className="absolute inset-y-0 right-0 flex items-center pr-2">
            <span className="text-gray-500 sm:text-sm">лет</span>
          </div>
        </div>
      </div>

      <div className="mb-2">
        <div className="relative flex gap-x-3">
          <div className="flex h-6 items-center">
            <input id="photo" name="photo" type="checkbox" className="h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500" {...form.register('has_avatar')} />
          </div>
          <div className="text-sm leading-6">
            <label htmlFor="photo" className="font-medium text-gray-900">
              Только с фото
            </label>
          </div>
        </div>
      </div>
      {!isFeedback && (
        <>
          {' '}
          <div className="mb-2">
            <DatePicker
              size="large"
              placeholder="Дата создания, от"
              className="w-full"
              value={created_at_from ? dayjs(created_at_from) : null}
              onChange={(e, s) => {
                form.setValue('created_at_from', s);
              }}
            />
          </div>
          <div className="mb-2">
            <DatePicker
              placeholder="Дата создания, до"
              size="large"
              className="w-full"
              value={created_at_to ? dayjs(created_at_to) : null}
              onChange={(e, s) => {
                form.setValue('created_at_to', s);
              }}
            />
          </div>
        </>
      )}

      <div className="mb-2 px-2 flex flex-col gap-y-2">
        {/* <button type="button" className="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-auto hover:text-white bg-white hover:bg-button transition ease-in-out duration-300">
          Выбрать по фильтру
        </button> */}
        {!isApplicants && !isFeedback && showSubmitButton && (
          <button disabled={disabled} type="button" className="text-center border rounded py-2 px-4 bg-button text-white hover:bg-button-hov mr-2 w-full transition ease-in-out duration-300 disabled:opacity-50" onClick={onSubmit}>
            {submitButtonText}
          </button>
        )}

        <button
          type="button"
          className="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-auto hover:text-white bg-white hover:bg-button transition ease-in-out duration-300"
          onClick={() => {
            setNumber();
            setFio();
            setAgeFrom();
            setAgeTo();
            form.reset({
              sex: 'null',
              number: '',
              full_name: '',
              age_from: '',
              age_to: '',
              has_avatar: false,
              created_at_to: null,
              created_at_from: null,
              userChecked: {},
              activeTab: form.watch('activeTab'),
            });

            // form.setValue('number', '');
            // form.setValue('age_from', '');
            // form.setValue('age_to', '');
            // form.setValue('has_avatar', false);
            // form.setValue('created_at_to', '');
            // form.setValue('created_at_from', '');
          }}>
          Сбросить
        </button>
      </div>
    </div>
  );
}

export default SelectionFilter;
